import React, { useEffect } from 'react'
import styled from 'styled-components'

import JaasLogo from '~/components/icons/jaas-logo'
import { ColumnFlexCentered, Flex } from '~/components/common/containers'
import { H1 } from '~/components/common/headers'
import { translate } from '~/core/translate'
import analytics from '~/services/analytics'

const Container = styled(ColumnFlexCentered)`
  margin: auto;
  text-align: center;

  ${H1} {
    margin: 24px auto 16px;
  }

  @media only screen and (min-width: 768px) and (min-height: 376px) {
    max-width: 600px;
  }
`

const CancelPage = () => {
  useEffect(() => {
    analytics.trackFailedEvent(analytics.EVENT_NAMES.UPGRADE_TO_PRO, { userType: analytics.USER_TYPE.VPAAS })
  }, [])

  return (
    <Flex fullWidth fullHeight>
      <Container>
        <JaasLogo />

        <H1>{translate('order_canceled_jaas')}</H1>
      </Container>
    </Flex>
  )
}

export default CancelPage
